module.exports = __webpack_public_path__ + "img/lnk-new-lead.59b63260.svg";